import React, { useEffect, useState } from 'react';
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from '../../../../_metronic/_partials/controls';
import Table, {
	dateFormatter,
	buttonsStyle
} from '../../../components/tables/table';
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog';
import { getAdvertisements, deleteAdvertisement, changeStatusAdvertisement } from '../../../../api/advertisement';
import { Button, Tooltip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { alertError, alertSuccess } from '../../../../utils/logger';
import { useHistory } from 'react-router-dom';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import { shallowEqual, useSelector } from 'react-redux';

function getData(advertisements) {
	let data = [];
	for (let i = 0; i < advertisements.length; ++i) {
		const elem = {};
		elem.title = advertisements[i].title;
		elem.linkURL = advertisements[i].linkURL;
		elem.createdAt = advertisements[i].createdAt;
		elem.id = advertisements[i]._id;
		elem.active = advertisements[i].active;
		data = data.concat(elem);
	}
	return data;
}

export default function AdvertisementsPage() {
	const [data, setData] = useState([]);
	const [advertisementId, setAdvertisementId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();
	const user = useSelector((store) => store.authentication?.user, shallowEqual)

	function buttonFormatter(cell) {
		const elem = data.find(item => item.id === cell)
		return (
			<>
				<Tooltip title='Edit'>
					<Button
						style={buttonsStyle}
						size='small'
						onClick={() => history.push('/edit-advertisement/' + cell)}>
						<EditIcon />
					</Button>
				</Tooltip>
				{user?.role.includes('admin') && <>
					<Tooltip title={elem?.active ? "Disable" : "Enable"}>
						<Button
							style={buttonsStyle} size="small"
							onClick={() => {
								setAdvertisementId(elem)
								setOpenConfirmDialog(1)
							}}>
							{elem?.active ? <ToggleOffIcon/> : <ToggleOnIcon style={{ color: 'red' }} />}
						</Button>
					</Tooltip>
					<Tooltip title='Delete'>
						<Button
							style={buttonsStyle}
							size='small'
							onClick={() => {
								setAdvertisementId(cell);
								setOpenConfirmDialog(2);
							}}>
							<DeleteIcon />
						</Button>
					</Tooltip>
				</>}
			</>
		);
	}

	const columns = [
		{ dataField: 'title', text: 'Title', sort: true },
		{ dataField: 'linkURL', text: 'Link URL', sort: true, formatter: cell => <a href={cell} target="_blank" rel="noopener noreferrer">{cell}</a> },
		{
			dataField: 'createdAt',
			text: 'Created at',
			formatter: dateFormatter,
			sort: true,
		},
		{ dataField: 'id', text: '', formatter: buttonFormatter },
	];

	useEffect(() => {
		getAdvertisements()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({ error: error, customMessage: 'Could not get advertisements.' });
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title='Advertisements list'>
					<CardHeaderToolbar>
						<button
							type='button'
							className='btn btn-primary'
							onClick={() => history.push('/edit-advertisement')}>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={`Are you sure you want to ${advertisementId?.active ? 'disable' : 'enable'} this advertisement?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusAdvertisement(advertisementId.id, !advertisementId?.active)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({ title: `${advertisementId?.active ? 'Disabled!' : 'Enabled!'}`, customMessage: `Advertisement ${advertisementId?.active ? 'disabled' : 'enabled'} successfully` })
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({ error: error, customMessage: `Could not ${advertisementId?.active ? 'disable' : 'enable'} advertisement.` })
								});
						}}
					/>
					<ConfirmDialog
						title={'Are you sure you want to remove this advertisement?'}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteAdvertisement(advertisementId)
								.then((res) => {
									if (res.status === 204 || res.status === 200) {
										alertSuccess({
											title: 'Deleted!',
											customMessage: 'Advertisement removed successfully.',
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: 'Could not remove advertisement.',
									});
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
